import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export class ModalGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal: props.showInitial || false,
    };
  }

  handleHide() {
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <div id="modal-wrap-alert-modal">
        <div className="modal-container">
          <Modal
            show={this.state.showModal}
            container={this.props.container}
            onHide={this.handleHide}
            bsSize="large"
            backdrop="static"
            aria-labelledby="contained-modal-title-lg"
          >
            <Modal.Header>
              <Modal.Title>{this.props.MessageTitle}</Modal.Title>
              <Button
                className={this.props.NoX + ''}
                onClick={() => {
                  this.handleHide();
                  this.props.MainButtonAction && this.props.MainButtonAction();
                }}
              >
                <i className="fa fa-times"></i>
              </Button>
            </Modal.Header>
            <Modal.Body>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 modal-error-body">
                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3 left-error-modal">
                  <i className={this.props.Icono + ' ' + this.props.colorIco + ' icon-error-modal'}></i>
                </div>
                <div className="col-xs-12 col-sm-9 col-md-9 col-lg-9 right-error-modal">
                  <h4>{this.props.msg}</h4>
                </div>
              </div>
              <div className="inner-Model-buttons">
                <Button
                  className={this.props.NoAceptar + ' btn btn-primary btn-si btn-left'}
                  onClick={() => {
                    this.handleHide();
                    this.props.MainButtonAction();
                  }}
                >
                  {this.props.MainButtonText}
                </Button>
                <Button
                  className={this.props.NoCancelar + ' btn btn-default btn-no btn-right'}
                  onClick={() => {
                    this.handleHide();
                    this.props.AltButtonAction();
                  }}
                >
                  {this.props.AltButtonText}
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}
